import React, { useRef, useState, useEffect } from 'react';
import EvaAvatar from './EvaAvatar.jsx';

const INTRO_VIDEO_URL = '/Cringe-Quest-Intro.mp4';

const EvaLiveChat = ({ onComplete }) => {
  const videoRef = useRef(null);
  const [audioVolume, setAudioVolume] = useState(0);
  const audioCtxRef = useRef(null);
  const analyserRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // 1. Allow same-origin processing (now it's on Netlify)
    video.crossOrigin = 'anonymous';
    video.playsInline = true;

    let rafId;

    const handlePlay = async () => {
      //console.log('📺 play event fired');
      //console.log('🎬 play fired; muted:', video.muted);

      // clear the mute so we actually get audio
      video.muted = false;

      // Create context & analyser once
      if (!audioCtxRef.current) {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        //console.log('🔊 created AudioContext:', ctx.state);
        const analyser = ctx.createAnalyser();
        analyser.fftSize = 256;

        const src = ctx.createMediaElementSource(video);
        // route audio both to analyser AND to speakers
        src.connect(analyser);
        src.connect(ctx.destination);

        audioCtxRef.current = ctx;
        analyserRef.current = analyser;
      }

      const ctx = audioCtxRef.current;
      if (ctx.state === 'suspended') {
        await ctx.resume();
        //console.log('🔄 resumed AudioContext:', ctx.state);
      }

      // start polling
      const analyser = analyserRef.current;
      const data = new Uint8Array(analyser.frequencyBinCount);
      const tick = () => {
        analyser.getByteTimeDomainData(data);
        let sum = 0;
        for (let i = 0; i < data.length; i++) {
          const n = (data[i] - 128) / 128;
          sum += n * n;
        }
        const rms = Math.sqrt(sum / data.length);
        //console.log('🎚 RMS:', rms.toFixed(3));
        setAudioVolume(rms);
        rafId = requestAnimationFrame(tick);
      };
      tick();
    };

    video.addEventListener('play', handlePlay);

    return () => {
      video.removeEventListener('play', handlePlay);
      cancelAnimationFrame(rafId);
      if (
        audioCtxRef.current &&
        audioCtxRef.current.state !== 'closed'
      ) {
        audioCtxRef.current.close();
        audioCtxRef.current = null;
      analyserRef.current = null;
      }
    };
   }, [] );

  const handleEnded = () => {
    if (onComplete) onComplete();
  };

  return (
    <div className="eva-live-chat">
      <div className="eva-live-chat__avatar">
        <EvaAvatar message="" audioVolume={audioVolume * 350} />
      </div>
      <div className="eva-live-chat__video-wrap">
        <video
          ref={videoRef}
          src={INTRO_VIDEO_URL}
          autoPlay
          playsInline
          onEnded={handleEnded}
          className="eva-live-chat__video"
        />
      </div>
    </div>
  );
};

export default EvaLiveChat;
